import React, { useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Space,
  Row,
  Col,
  Select,
  InputNumber,
} from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const formatCurrency = (value) => {
  if (!value) return '';
  return `NGN ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const parseCurrency = (value) => {
  if (!value) return '';
  return value.replace(/(NGN|\s|,)/g, '');
};

const ItemForm = ({
  initialValues,
  onSubmit,
  onCancel,
  departments = [],
  categories = [],
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter item name' }]}
          >
            <Input placeholder="Enter item name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="storeDepartmentId"
            label="Department"
            rules={[{ required: true, message: 'Please select a department' }]}
          >
            <Select placeholder="Select a department">
              {departments.map(department => (
                <Option key={department.id} value={department.id}>{department.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="categoryId"
            label="Category"
            rules={[{ required: true, message: 'Please select a category' }]}
          >
            <Select placeholder="Select a category">
              {categories.map(category => (
                <Option key={category.id} value={category.id}>{category.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="quantityInStock"
            label="Quantity In Stock"
            rules={[
              { required: true, message: 'Please enter quantity' },
              { type: 'number', min: 0, message: 'Quantity must be positive' },
            ]}
          >
            <InputNumber style={{ width: '100%' }} placeholder="Enter quantity" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="unitPrice"
            label="Unit Price"
            rules={[
              { required: true, message: 'Please enter unit price' },
              { type: 'number', min: 0, message: 'Price must be positive' },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Enter unit price"
              formatter={formatCurrency}
              parser={parseCurrency}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="costPrice"
            label="Cost Price"
            rules={[
              { required: true, message: 'Please enter cost price' },
              { type: 'number', min: 0, message: 'Price must be positive' },
            ]}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Enter cost price"
              formatter={formatCurrency}
              parser={parseCurrency}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="reorderLevel"
            label="Reorder Level"
            rules={[
              { required: true, message: 'Please enter reorder level' },
              { type: 'number', min: 0, message: 'Reorder level must be positive' },
            ]}
          >
            <InputNumber style={{ width: '100%' }} placeholder="Enter reorder level" />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="description"
        label="Description"
      >
        <TextArea
          placeholder="Enter item description"
          rows={4}
        />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
